import { icons } from "../assets/icons";

export const techStack = [
  "Javascript",
  "Typescript",
  "React",
  "Next.js",
  "Tailwind",
  "Node.js",
  "Express",
  "MySQL",
  "MongoDB",
  "Firebase",
  "Supabase",
  "Python",
];

export const projects = [
  {
    name: "BinGoals",
    description:
      "A mobile app that turns your goals into a bingo game, complete with unlockable achievements to keep you motivated.",
    link: "expo.dev/knotz/bingoals",
    url: "https://expo.dev/accounts/knotz/projects/bingoals/builds/39b39649-f3cb-491f-bde7-e563a7a64bd6",
  },
  {
    name: "OJTFolio",
    description:
      "A SaaS web app that helps students track OJT hours with file uploads, daily time logs, and automated weekly reports.",
    link: "ojtfolio.systems",
    url: "https://ojtfolio.systems",
  },
  {
    name: "CodeCollab",
    description:
      "CodeCollab is a real-time collaborative IDE built for seamless group or pair programming sessions.",
    link: "codlab.vercel.app",
    url: "https://codlab.vercel.app",
  },
  {
    name: "MAR: Menu Augmented Resto",
    description:
      "A web app with an interactive 3D menu. Built to make ordering system more efficient.",
    link: "travelmugcafemenu.netlify.app",
    url: "https://travelmugcafemenu.netlify.app",
  },
  {
    name: "Keyed Vigenere Cipher",
    description: "Encrypt and decrypt messages using a custom cipher key.",
    link: "vigenereverse.netlify.app",
    url: "https://vigenereverse.netlify.app",
  },
  {
    name: "SafeVenture",
    description:
      "Android app that monitors login attempts, sends image alerts, and shares friends.",
    link: "safeventure.netlify.app",
    url: "https://safeventure.netlify.app",
  },

  {
    name: "Midnight Coding",
    description: "A vscode theme designed for late night coding.",
    link: "github.com/AlnickClores/Mignight-Code",
    url: "https://github.com/AlnickClores/Midnight-Code",
  },
  {
    name: "Cumulus",
    description:
      "A web app that provides real-time weather using OpenWeather API.",
    link: "alnickclores.github.io/Cumulus",
    url: "https://alnickclores.github.io/Cumulus",
  },
  {
    name: "Quote Generator",
    description:
      "A website that generates inspirational quotes from influencial people",
    link: "alnickclores.github.io/QuoteGenerator",
    url: "https://alnickclores.github.io/QuoteGenerator/year_end_proj/quote.html",
  },
  {
    name: "To-Do List",
    description: "A To-Do list web app.",
    link: "alnickclores.github.io/todolist-app",
    url: "https://alnickclores.github.io/todolist-app/",
  },
];

export const blogPost = [
  {
    title: "Just Get Started: Build, Learn Improve",
    content:
      "Start with anything. Start with any little pieces of junk on your screen or paper that you can think of. Don’t worry about the way it looks, don’t worry about making it perfect. We don’t make a perfect project and build the next perfect project. We build a ugly one and we cover it in pain and with another layer or paint until it’s the way we wanted it to be. If you try to build something perfect in the beginning, you’re most likely to fail.",
    url: "https://medium.com/@aelnickclores/just-get-started-build-learn-improve-d4b30eee48e6",
  },
  {
    title: "Life Lessons from Video Games: Learning Through Failure",
    content:
      "In the classic game Super Mario, there’s a unique feature when you move to the right, the screen follows you, and you can’t go back. The game never tells you this rule directly you figure it out as you play. Video games often teach us lessons this way, not through words but through experience.",
    url: "https://medium.com/@aelnickclores/life-lessons-from-video-games-learning-through-failure-2726447899a3",
  },
  {
    title:
      "Python OOP: Encapsulation, Inheritance, Abstraction, and Polymorphism",
    content:
      "Object-Oriented Programming (OOP) is built around the idea of 'objects' and plays a vital role in modern programming. Understanding OOP is essential because it helps us create code that is reusable, modular, and easier to maintain..",
    url: "https://medium.com/@aelnickclores/python-oop-encapsulation-inheritance-abstraction-and-polymorphism-3df38b49a986",
  },
];

export const certifications = [
  {
    name: "Generative AI: Prompt Engineering",
    provider: "IBM",
    url: "https://coursera.org/share/b958edf06e44a4fe8ded0c6b61f2cb85",
  },
  {
    name: "Meta Frontend Developer",
    provider: "Meta",
    url: "https://coursera.org/share/0821b1466673f5b6dfced802c6d90063",
  },
  {
    name: "Advanced React",
    provider: "Meta",
    url: "https://coursera.org/share/b3e2d907ff6163d249f7f38500fdec7c",
  },
  {
    name: "Programming with Javascript",
    provider: "Meta",
    url: "https://www.coursera.org/account/accomplishments/verify/G5P0H2IITLVX",
  },
  {
    name: "Programming Essentials in Python",
    provider: "OpenEDG Python Institute",
    url: "/PCAP-Certificate.pdf",
  },
  {
    name: "Python",
    provider: "Certiport - A Pearson VUE Business",
    url: "/Python - IT Specialist.pdf",
  },
  {
    name: "Javascript Data Structure and Algorithm",
    provider: "freeCodeCamp",
    url: "https://www.freecodecamp.org/certification/Alnick_Clores/javascript-algorithms-and-data-structures",
  },
  {
    name: "Github Foundations",
    provider: "GitHub",
    url: "https://www.credly.com/badges/181b5471-d878-4b9f-93c6-7c6bc7c9dd0f/print",
  },
  {
    name: "Responsive Web Design",
    provider: "freeCodeCamp",
    url: "https://www.freecodecamp.org/certification/Alnick_Clores/responsive-web-design",
  },
  {
    name: "Python Programming Fundamentals",
    provider: "Microsoft",
    url: "https://www.coursera.org/account/accomplishments/verify/4LXSS9QXUPOF",
  },
];

export const socialLinks = [
  {
    icon: icons.linkedin,
    link: "https://www.linkedin.com/in/alnickdev",
    ariaLabel: "LinkedIn Profile",
  },
  {
    icon: icons.github,
    link: "https://github.com/AlnickClores",
    ariaLabel: "GitHub Profile",
  },
  {
    icon: icons.twitch,
    link: "https://www.twitch.tv/knotz2k3",
    ariaLabel: "Twitch Profile",
  },
];
